import gql from 'graphql-tag';

const GET_USER_SUBSCRIPTIONS = gql`
    query getUserSubscriptions {
        getUserSubscriptions
        {
            id,
            walletAddress,
            duration,
            tickets,
            totalToken,
            lockTrxHash,
            unlockTrxHash,
            isVerified,
            lockedAt,
            expiresAt,
            expiresAt,
            status,
            networkId,
            scVersion,
        }
    }
`

export default GET_USER_SUBSCRIPTIONS;